import { ParametreContextuelDto } from './parametre-contextuel-dto.model';
import { PersonnePhysiqueDto } from './personne-physique-dto.model';
import { RoleMetierDto } from './role-metier-dto.model';
import { StructureDto } from './structure-dto.model';

export class HabilitationDto {
  clePerimetreContextuel: any;

  constructor(
    public parametreContextuel?: ParametreContextuelDto,
    public numeroContrat?: string,
    public etat?: string,
    public dateDebut?: string,
    public dateFin?: string,
    public structure?: StructureDto,
    public personneHabilitee?: PersonnePhysiqueDto,
    public demandeur?: PersonnePhysiqueDto,
    public acteur?: PersonnePhysiqueDto,
    public roleMetier?: RoleMetierDto,
    public id?: string,
    public isSelected = false,
    public cleContrat?: string,
    public clePerimetreContractuel?: string,
    public cleParametreContextuel?: string,
    public idPersonneAffichageTableauHab?: string,
    public usage?: string,
    public solution?: string,
    public editeurSolution?: string,
    public numDossierGrc?: string,
    public test = false,
    public creePar?: PersonnePhysiqueDto,
    public modifiePar?: PersonnePhysiqueDto,
    public typeOffre?: string,
    public idStructure?: string,
    public structureHabilitee?: StructureDto,
    public cleStructureHabilitee?: string,
    public dateCreation?: string,
    public libelleEtat?: string
  ) { }
}

export interface HabilitationStructureDto {
  idNatStruct: string;
  profils?: string[];
}

export interface HabilitationLiberalDto {
  idNatPS: string;
  profil: string;
  referenceContrat: ReferenceContrat;
  structure: StructureLiberale;
  offre: string;
  parametreContextuel: ParametreContextuelLiberale;
}

export interface ResponseHabStructureDto extends HabilitationLiberalDto {
  statut?: string;
}

export interface ReferenceContrat {
  typeContrat: string;
  identifiant: string;
  dateCreation?: string;
  etatContrat?: string;
  indicateurAbonne: boolean;
  dateRattachementStructure?: string;
}

export interface StructureLiberale {
  idNatStruct?: string;
  raisonSociale?: string;
  codePostal?: string;
  commune?: string;
  // TODO: añadidos solo para el front
  clePerimetreContractuel?: string;
  cleContrat?: string;
  statutRass?: boolean;
}
export interface StructureAndParamLiberale extends StructureLiberale {
  offre?: string;
  domaine?: string;
  restriction?: RestrictionCode;
  isOffrePS?: boolean;
}

export interface ParametreContextuelLiberale {
  domaine: string;
  restriction: RestrictionCode;
  typeParametre: TypeParametre;
}

export enum RestrictionCode {
  AVEC,
  PARTIELLE,
  SANS,
}

export enum TypeParametre {
  TOUT,
  SERVEUR,
  MESS,
}
